export default __webpack_public_path__ + "static/toman-cde77b01f2ee0d2a6694210bf6b22eff.svg";